module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"reidaTitle":"REIDA Emissionsfaktoren","sourceText":"Energieträger und Emissionsfaktoren, welche für die Erstellung des Reports nach REIDA verwendet werden.","openLink":"Quelle öffnen"}}')
  delete Component.options._Ctor
}
